import { DesignUploadMode } from '../../interfaces';
import { calculateSetupFeePerItem } from '../calculate-setup-fee-value.logic';
import { getDataForGettingItemShippingCost, getItemShippingCost } from './get-item-shipping-cost.service';
function getSetupFeeToUseForPricePerItemCalculation(items, allOrderItems) {
  return items.reduce((result, item) => {
    let setupFee = calculateSetupFeePerItem({
      item,
      allOrderItems
    });
    if (item.setupFeeDeductionDiscount) {
      setupFee = setupFee - item.setupFeeDeductionDiscount;
    }
    return result + setupFee;
  }, 0);
}
export const getBoxItemsPricing = ({
  items,
  allOrderItems,
  options
}) => {
  const box = items.find(i => {
    var _i$prod;
    return ((_i$prod = i.prod) === null || _i$prod === void 0 ? void 0 : _i$prod.designUploadMode) === DesignUploadMode.box;
  });
  if (!box) {
    return {
      total: 0,
      itemPrice: 0,
      totalBoxSetupFee: 0
    };
  }
  const {
    quantity
  } = box;
  const shippingPrice = getItemShippingCost(getDataForGettingItemShippingCost(box, items));
  const totalItemsPrice = items.reduce((all, next) => all + next.price, 0);
  let total = totalItemsPrice;
  if (options !== null && options !== void 0 && options.totalWithShipping) {
    total += shippingPrice;
  }
  const totalBoxSetupFee = getSetupFeeToUseForPricePerItemCalculation(items, allOrderItems);
  const itemPrice = (totalItemsPrice - totalBoxSetupFee) / quantity;
  return {
    total,
    itemPrice,
    totalBoxSetupFee
  };
};